/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';

const WindIndicator = ({
  direction,
  speed,
  units
}) => {
  const adjustedSpeed = Math.round(speed);
  return /*#__PURE__*/React.createElement("svg", {
    className: "quiver-wind-indicator"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: `rotate(${direction} 17.5 17.5)`
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.5 2.75, 17.5 2.5, 20.5 2.75, 17.5 6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "51%"
  }, adjustedSpeed), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "70%"
  }, units))));
};

WindIndicator.defaultProps = {
  direction: 0,
  speed: 0,
  units: ''
};

export default WindIndicator;
//# sourceMappingURL=WindIndicator.js.map
